import { IArticle, IDosage, IQuantityPerUnit } from '@alberta/konexi-shared';
import { ignore } from 'src/app/common/tracking/tracker';
import { PredefinedArticleDto } from 'src/app/shared/models/article/predefined-article-dto.model';

import { IOrderMaximumQuantity } from '../order/contracts/order-maximum-quantity';
import { IShoppingCartMaxAmountArticleLine } from './shopping-cart-max-amount-article-view-model';

export class ShoppingCartArticleViewModel implements IShoppingCartMaxAmountArticleLine {
  _id: string;
  articleId: string;
  dosage: IDosage;
  annotation: string;
  productGroupId?: string;
  isPrivateSale: boolean;
  notAutomaticDelivery: boolean;

  @ignore()
  seriesDataId: string;

  @ignore()
  associatedArticle: IArticle;

  @ignore()
  associatedPackageingUnit: IQuantityPerUnit;

  @ignore()
  associatedPredifinedArticleLine?: PredefinedArticleDto;

  @ignore()
  hideInShoppingCart?: boolean;
  @ignore()
  maxAmount: IOrderMaximumQuantity;
  @ignore()
  associatedQuantityPerUnit: IQuantityPerUnit;
}
